import { render, staticRenderFns } from "./login-app.vue?vue&type=template&id=6504a81e"
import script from "./login-app.vue?vue&type=script&lang=js"
export * from "./login-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports